import { render, staticRenderFns } from "./assemblyNew.vue?vue&type=template&id=bc118e8e&scoped=true&"
import script from "./assemblyNew.vue?vue&type=script&lang=js&"
export * from "./assemblyNew.vue?vue&type=script&lang=js&"
import style0 from "./assemblyNew.vue?vue&type=style&index=0&id=bc118e8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc118e8e",
  null
  
)

export default component.exports